import { Button } from '@cian/ui-kit';
import { TButtonSize } from '@cian/ui-kit/button/types';
import * as React from 'react';

export interface IPhoneButtonProps {
  buttonSize?: TButtonSize;
  fullWidth?: boolean;
  onClick(): void;
}

export function PhoneButton({ buttonSize = 'XS', fullWidth, onClick }: IPhoneButtonProps) {
  return (
    <Button size={buttonSize} fullWidth={fullWidth} onClick={onClick}>
      Показать телефон
    </Button>
  );
}
